import { defineMessages } from 'react-intl';

export const MAX_ITEM_DETAILS = 5;
export const MIN_PHOTO_WIDTH = 500;
export const MIN_PHOTO_HEIGHT = 300;
export const MAX_PHOTO_SIZE = 25 * 1024 * 1024; // 25MB;

export const GA_TRACKING_DISPLAYED = 'trade sourcing displayed';
export const GA_TRACKING_ENTRY = 'trade sourcing entry';
export const GA_TRACKING_SUBMITTED = 'trade sourcing submitted';

export const ONE_MONTH = '1 Month';
export const TWO_MONTHS = '2 Months';
export const THREE_MONTHS = '3 Months';
export const FOUR_MONTHS = '4+ Months';
export const UNKNOWN_TIMEFRAME = 'Unknown';

export type NextProjectTimeframeOption =
    | typeof ONE_MONTH
    | typeof TWO_MONTHS
    | typeof THREE_MONTHS
    | typeof FOUR_MONTHS
    | typeof UNKNOWN_TIMEFRAME
    | '';

export const ITEM_TYPE_ANTIQUE = 'antique/vintage';
export const ITEM_TYPE_CONTEMPORARY = 'new/custom';

export const SOURCING_PROMPT_MODAL_ORIGIN_FOLDER = 'folder';
export const SOURCING_PROMPT_MODAL_ORIGIN_PROJECT = 'project';

export type SourcingPromptModalOrigin =
    | typeof SOURCING_PROMPT_MODAL_ORIGIN_FOLDER
    | typeof SOURCING_PROMPT_MODAL_ORIGIN_PROJECT;

export const sourcingTimeframeOptions = defineMessages({
    '1': {
        id: 'dc.tradeSourcing.pdpSourcingForm.timeFrameOptions.lessThanMonth',
        defaultMessage: 'Less than 1 month',
    },
    '1-3': {
        id: 'dc.tradeSourcing.pdpSourcingForm.timeFrameOptions.1-3months',
        defaultMessage: '1-3 months',
    },
    '4-6': {
        id: 'dc.tradeSourcing.pdpSourcingForm.timeFrameOptions.4-6months',
        defaultMessage: '4-6 months',
    },
    '7-9': {
        id: 'dc.tradeSourcing.pdpSourcingForm.timeFrameOptions.7-9months',
        defaultMessage: '7-9 months',
    },
    '10-12': {
        id: 'dc.tradeSourcing.pdpSourcingForm.timeFrameOptions.10-12months',
        defaultMessage: '10-12 months',
    },
    '12+': {
        id: 'dc.tradeSourcing.pdpSourcingForm.timeFrameOptions.overYear',
        defaultMessage: 'Over a year',
    },
});
